import React, { useEffect, useState } from "react";
import axios from "axios";
import { useUser } from "../../context/UserContext";
import Spinner from "react-bootstrap/Spinner";
import useAuth from "../../hooks/useAuth";

const Customers = () => {
  useAuth();
  const { user, loading } = useUser();
  const [reports, setReports] = useState([]);
  const [loadingReports, setLoadingReports] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchReports = async () => {
      const token = localStorage.getItem("access_token");
      if (!token) {
        setError("No access token found");
        setLoadingReports(false);
        return;
      }

      try {
        const params = new URLSearchParams();
        params.append("deviceid", "default-device");
        params.append("page_name", "subscribed");
        params.append("return_filters", "0");
        params.append("page", "0");
        params.append("order_by", "publish_date");
        params.append("sort", "desc");

        const response = await axios.post(
          "https://growthiq.mnmks.com/growth_iq_api_proxy/ks/get_subscribed_reports",
          params,
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
              "X-KS-Auth": token,
            },
          }
        );

        if (
          response?.data?.status === 200 &&
          response?.data?.data?.report_list
        ) {
          const fetchedReports = response.data.data.report_list;
          console.log("Fetched Reports:", fetchedReports);
          setReports(fetchedReports);
        } else {
          setError("Failed to load reports");
        }
      } catch (err) {
        console.error("Error fetching reports:", err);
        setError("Error fetching reports");
      } finally {
        setLoadingReports(false);
      }
    };

    fetchReports();
  }, []);

  if (loading || loadingReports) {
    return (
      <div
        style={{
          height: "100vh",
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          backgroundColor: "#f8f9fa",
        }}
      >
        <Spinner
          animation="border"
          variant="primary"
          style={{ width: "3rem", height: "3rem" }}
        />
        <div
          style={{
            marginTop: "20px",
            fontSize: "16px",
            fontWeight: "500",
            color: "#6c757d",
          }}
        >
          Loading Reports...
        </div>
      </div>
    );
  }

  if (!user) {
    return <div style={{ padding: "30px" }}>Please log in.</div>;
  }

  const email = user.email;
  const companyName = user.company_name_for_growth_iq || user.company_name;

  if (reports.length > 0) {
    const reportNames = reports
      .map((r) => r.short_title || r.report_title)
      .join(",");
    const url = `https://salesplay.marketsandmarkets.com/get_inside_sp/${email}/${encodeURIComponent(
      companyName
    )}/${encodeURIComponent(reportNames)}`;
    console.log("URL:", url);
    return (
      <div
        style={{
          height: "100vh",
          width: "100%",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <iframe
          src={url}
          title="Customers"
          style={{
            flex: 1,
            width: "100%",
            height: "100%",
            border: "none",
            display: "block",
            margin: 0,
            padding: 0,
          }}
        />
      </div>
    );
  }

  return (
    <div
      style={{
        padding: "30px",
        backgroundColor: "#f8f9fa",
        minHeight: "100vh",
      }}
    >
      <h2 style={{ marginBottom: "25px", color: "#1a1a1a" }}>
        Subscribed Reports
      </h2>
      {error && (
        <div style={{ color: "red", marginBottom: "15px" }}>{error}</div>
      )}
      <p>No subscribed reports found.</p>
    </div>
  );
};

export default Customers;
